/* eslint-disable import/no-useless-path-segments */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-unresolved */
/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/self-closing-comp */
import { Button, Grid, Modal, Typography, makeStyles, useTheme } from '@material-ui/core';
import '@fontsource/lexend';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { motion } from 'framer-motion';
import person from '../../../../src/assets/Assunto.png';

const useStyles = makeStyles((theme) => ({
  modal: {
    backgroundColor: '#FFF',
  },
  gridContainer: {
    width: '100%',
    height: '100%',
    backgroundColor: '#FFF',
    overflowY: 'auto',
  },
  banner: {
    backgroundColor: '#f3986f',
    borderRadius: '0 5px 5px 0',
    minHeight: '540px',
  },
  bannerRow1: {
    height: '40%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    padding: '0px 0px 5% 35%',
  },
  bannerRow2: {
    height: '60%',
    position: 'relative',
  },
  awaitEmail: {
    color: '#FFF',
    fontWeight: 700,
    letterSpacing: '.1rem',
    fontFamily: 'Lexend',
    fontSize: '4.5rem',
    textShadow: '2px 2px 4px rgba(255, 255, 255, 0.1)',
  },
  info: {
    minHeight: '540px',
  },
  infoRow1: {
    height: '45%',
    borderBottom: '3px solid #c0c0c0d6',
    borderRadius: '2px',
    width: '99%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0px 0px 6% 0',
  },
  infoRow2: {
    height: '55%',
  },
  successMessage: {
    fontWeight: 700,
    letterSpacing: '.1rem',
    fontFamily: 'Lexend',
    fontSize: '2.3rem',
    textTransform: 'uppercase',
    color: '#32653b',
    textShadow: '2px 2px 4px rgba(255, 255, 255, 0.1)',
  },
  checkIcon: {
    fontSize: '4.5rem',
    margin: '0 0 15px 0',
    color: '#44ab55e2',
  },
  infoRow2Message: {
    height: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 0 50px 0',
  },
  infoRow2Button: {
    height: '50%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  infoMessage: {
    fontWeight: 400,
    letterSpacing: '.1rem',
    fontFamily: 'Lexend',
    fontSize: '1.9rem',
    color: '#32653bd6',
    textShadow: '2px 2px 4px rgba(255, 255, 255, 0.1)',
    width: '100%',
    textAlign: 'center',
  },
  confirmButton: {
    width: '17rem',
    borderRadius: '0',
    fontWeight: 700,
    padding: '0',
    letterSpacing: '.1rem',
    fontFamily: 'Lexend',
    fontSize: '2.4rem',
    textTransform: 'uppercase',
    backgroundColor: '#32653b',
    color: '#FFF',
    textShadow: '2px 2px 4px rgba(255, 255, 255, 0.1)',
    transition: 'all .5s',
    '&:hover': {
      backgroundColor: '#32653bae',
    },
  },
  [theme.breakpoints.up('xs')]: {
    image: {
      width: 240,
      objectFit: 'fill',
      position: 'absolute',
      top: '-20px',
      left: '30px',
    },
    awaitEmail: {
      color: '#FFF',
      fontWeight: 700,
      letterSpacing: '.1rem',
      fontFamily: 'Lexend',
      fontSize: '3rem',
      textShadow: '2px 2px 4px rgba(255, 255, 255, 0.1)',
    },
    bannerRow1: {
      height: '40%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
      padding: '0px 0px 5% 35%',
      overflowX: 'hidden',
    },
    bannerRow2: {
      height: '60%',
      position: 'relative',
    },
    successMessage: {
      fontWeight: 700,
      letterSpacing: '.1rem',
      fontFamily: 'Lexend',
      fontSize: '1.6rem',
      textTransform: 'uppercase',
      color: '#32653b',
      textAlign: 'center',
      textShadow: '2px 2px 4px rgba(255, 255, 255, 0.1)',
    },
    infoRow2Message: {
      height: '50%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      margin: '1.2rem 0 1.2rem 0',
      padding: '0',
    },
    infoRow2Button: {
      height: '50%',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
    infoMessage: {
      fontWeight: 400,
      letterSpacing: '.1rem',
      fontFamily: 'Lexend',
      fontSize: '1.9rem',
      color: '#32653bd6',
      textShadow: '2px 2px 4px rgba(255, 255, 255, 0.1)',
      width: '100%',
      textAlign: 'center',
    },
  },
  [theme.breakpoints.up('sm')]: {
    image: {
      width: 320,
      objectFit: 'fill',
      position: 'absolute',
      top: '-80px',
      left: '30px',
    },
    awaitEmail: {
      fontSize: '3.6rem',
    },
    bannerRow1: {
      height: '40%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
      padding: '0px 0px 5% 40%',
      overflowX: 'hidden',
    },
    infoRow2Message: {
      height: '50%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      margin: '0',
      padding: '0',
    },
  },
  [theme.breakpoints.up('md')]: {
    image: {
      width: 320,
      objectFit: 'fill',
      position: 'absolute',
      top: '-60px',
      left: '30px',
    },
    infoRow2Message: {
      height: '50%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      margin: '0',
      padding: '10px 20px',
    },
  },
  [theme.breakpoints.up('lg')]: {
    image: {
      width: 440,
      left: '30px',
    },
    awaitEmail: {
      fontSize: '4.5rem',
    },
    successMessage: {
      fontSize: '1.9rem',
    },
    infoMessage: {
      fontSize: '2rem',
    },
  },
}));

const SuccessModal = ({ handleClose, setRedirect, open }) => {
  const classes = useStyles();
  const theme = useTheme();

  const handleConfirm = () => {
    setTimeout(() => {
      handleClose();
      setRedirect(true);
    }, 300);
  };

  return (
    <>
      <Modal open={open} className={classes.modal}>
        <Grid container className={classes.gridContainer}>
          <Grid item container xs="12" md="6" className={classes.banner}>
            <Grid item xs="12" className={classes.bannerRow1}>
              <Typography variant="h2" className={classes.awaitEmail}>
                Aguarde
              </Typography>
              <Typography variant="h2" className={classes.awaitEmail}>
                seu e-mail!
              </Typography>
            </Grid>
            <Grid item xs="12" className={classes.bannerRow2}>
              <img src={person} className={classes.image} alt="Icon" />
            </Grid>
          </Grid>

          <Grid item xs="12" md="6" className={classes.info}>
            <Grid item xs="12" className={classes.infoRow1}>
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}>
                <Typography variant="h2" className={classes.successMessage}>
                  <CheckCircleIcon className={classes.checkIcon} />
                </Typography>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}>
                <Typography variant="h2" className={classes.successMessage}>
                  Seu cadastro
                </Typography>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}>
                <Typography variant="h2" className={classes.successMessage}>
                  Foi efetuado com sucesso!
                </Typography>
              </motion.div>
            </Grid>

            <Grid item xs="12" className={classes.infoRow2}>
              <Grid item xs="12" className={classes.infoRow2Message}>
                <motion.div
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5 }}>
                  <Typography variant="h2" className={classes.infoMessage}>
                    Vamos analisar sua solicitação
                  </Typography>
                  <Typography variant="h2" className={classes.infoMessage}>
                    e em breve entraremos em contato!
                  </Typography>
                </motion.div>
              </Grid>

              <Grid item xs="12" className={classes.infoRow2Button}>
                <motion.div
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5 }}>
                  <Button className={classes.confirmButton} onClick={handleConfirm}>
                    OK
                  </Button>
                </motion.div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default SuccessModal;
